import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../customs/skeleton/main";

const Main = lazy(
  () => import("../../components/reports/licenseRegister/main")
);
const Main2 = lazy(
  () =>
    import(
      "../../components/reports/licenseRegister/firstTimeLicenseApplicants"
    )
);
const Main3 = lazy(
  () =>
    import(
      "../../components/reports/licenseRegister/hrLicenseStatus/hrLicenseStatus"
    )
);
const Main4 = lazy(
  () =>
    import(
      "../../components/reports/licenseRegister/hrWorkActivities/hrWorkActivities"
    )
);
const Main5 = lazy(
  () =>
    import(
      "../../components/reports/licenseRegister/licenseReport/licenseReport"
    )
);

const LicenseReports = () => {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Main />
    </Suspense>
  );
};

const FirstTimeLicenseApplicantReports = () => {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Main2 />
    </Suspense>
  );
};

const HrLicenseStatusReports = () => {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Main3 />
    </Suspense>
  );
};

const HrWorkActivitiesReports = () => {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Main4 />
    </Suspense>
  );
};

const LicenseReport = () => {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Main5 />
    </Suspense>
  );
};

export {
  LicenseReports,
  FirstTimeLicenseApplicantReports,
  LicenseReport,
  HrWorkActivitiesReports,
  HrLicenseStatusReports,
};
